import { Form, useNavigation } from "@remix-run/react";
import SubmitButton from "./SubmitButton";

type Props = {
  isActive: boolean;
};

const BusinessConfirmation: React.FC<Props> = ({ isActive }) => {
  const navigation = useNavigation();
  const isSubmitting = navigation.state === "submitting";

  if (!isActive) return null;

  return (
    <div className="flex flex-col gap-7 xsm:gap-4 md:gap-3.5 px-5 text-center">
      <h2 className="text-[20px] text-blue900 font-sans mt-[10px] uppercase font-bold">
        We&apos;ve lowered your prices.
      </h2>
      <img
        alt="Confirmation: Prices lowered for business members"
        className="w-10 h-10 mx-auto"
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO3N0cm9rZTojNzNhZTNiO3N0cm9rZS1saW5lY2FwOnNxdWFyZTtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6NHB4O308L3N0eWxlPjwvZGVmcz48dGl0bGU+Q2hlY2ttYXJrPC90aXRsZT48cG9seWxpbmUgY2xhc3M9ImEiIHBvaW50cz0iMy4xMyAxMC44NSA2LjQxIDE0LjYyIDE2Ljk4IDUuMjgiLz48L3N2Zz4="
      />
      <h3 className="text-[22px] text-blue900 font-sans mt-0 font-bold">
        Enjoy savings site-wide with your member pricing.
      </h3>
      <Form
        method="post"
        action="/resources/create-account-wizard"
        className="w-full text-left mt-[10px]"
      >
        <input
          type="hidden"
          name="intent"
          value="finish_registration"
        />
        <SubmitButton
          disabled={isSubmitting}
          label="Go shop"
          clickedLabel="Finishing..."
        />
      </Form>
    </div>
  );
};

export default BusinessConfirmation;
